module.exports = __webpack_public_path__ + "html/reactivation.template.html";